import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MessageDialogComponent } from '@components/message-dialog/message-dialog.component';
import { take } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MessageDialogService {
    constructor(
        private dialog: MatDialog,
        private translate: TranslateService
    ) {}
    private positionMaps: Map<string, number> = new Map();

    async openMessage(
        translationKey: string,
        params?: Record<string, any>,
        deleteEnableUndo: boolean = false,
        position?: { bottom?: string; right?: string }
    ) {
        const message = this.translate.instant(translationKey, params);
        const id = `dialog-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;

        if (this.positionMaps.size > 0) {
            this.positionMaps.forEach((position, dialogId) => {
                const oldDialog = this.dialog.getDialogById(dialogId);
                if (oldDialog) {
                    const newPosition = position + 55;
                    oldDialog.updatePosition({ bottom: `${newPosition}px`, right: '10px' });
                    this.positionMaps.set(dialogId, newPosition);
                } else {
                    this.positionMaps.delete(dialogId);
                }
            });
        }

        const dialog = this.dialog.open<MessageDialogComponent>(MessageDialogComponent, {
            id,
            data: { message, deleteEnableUndo, closeInterval: 4000 },
            position: {
                bottom: position?.bottom ?? '10px',
                right: position?.right ?? '10px',
            },
            backdropClass: 'transparent-backdrop',
            hasBackdrop: false,
        });

        this.positionMaps.set(id, 10);

        dialog
            .afterClosed()
            .pipe(take(1))
            .subscribe(() => {
                this.positionMaps.delete(id);
            });
    }

    async openCenteredMessage(
        translationKey: string,
        params?: Record<string, any>,
        iconSvgPath: string = '',
        top: string = '108px',
        left: string = '50%'
    ) {
        const message = this.translate.instant(translationKey, params);

        const dialogRef = this.dialog.open<MessageDialogComponent>(MessageDialogComponent, {
            data: { iconSvgPath, message, closeInterval: 4000 },
            position: {
                top: top,
                left: left,
            },
            panelClass: 'dialog-centered',
            backdropClass: 'transparent-backdrop',
            hasBackdrop: false,
        });

        return dialogRef;
    }
}
